export const trans = ( translations, key ) => {
     if ( translations.hasOwnProperty( key ) ) {
        return translations[key];
     }

    return key;

};

export const groupByKey = (xs, key) => {

    return xs.reduce((rv, x) => {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});

};

export const isRetina = () => {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
};

export const iosAndroidDetector = () => {

    let userAgent = navigator.userAgent,
        iOS = ( /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream ) || ( !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) ),
        isAndroid = userAgent.toLowerCase().indexOf('android') > -1 && userAgent.toLowerCase().indexOf('windows') === -1;

    if ( iOS ) {
        return 'ios';
    }

    if ( isAndroid ) {
        return 'android';
    }

    return null;

};

export const setSpaceAfterNLetter = ( str, n ) => {
    return str.replace(new RegExp( '^(.{' + n + '})' ), '$1 ');
};

export const setBracketsAfterFirstPart = ( str ) => {

    str = str.replace(/(\d)(?=(\d{2})+(?!\d))/g, '$1 ');

    str = '(' + str.split(' ')[0] + ')' + str.replace(/^\d\d/, '');

    return str;
};

export const applyDrag = (arr, dragResult) => {
    const { removedIndex, addedIndex, payload } = dragResult;
    if (removedIndex === null && addedIndex === null) return arr;

    const result = [...arr];
    let itemToAdd = payload;

    if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0];
    }

    if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
    }

    return result;
};

export const doubleNumber = ( n ) => {
    return ( n < 10 ) ? '0' + n : n;
};

export const setComoAfter3Symbol = ( number ) => {

    if ( isNaN( number ) ) {
        number = Number( number.toString().replace(/[^\d-]/g, '') );
    }

    // if ( number < 0 ) {
    //     number = Math.ceil( number * -1 ) * -1;
    // } else {
    //     number = Math.ceil( number );
    // }
    number = Math.round( number );

    return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

// Set como after 3 symbol
export const setComoAfterThirdSymbol = ( val ) => {

    if ( isNaN( val ) ) {
        val = Number( val.toString().replace(/[^\d-]/g, '') );
    }

    // if ( val < 0 ) {
    //     val = Math.ceil( val * -1 ) * -1;
    // } else {
    //     val = Math.ceil( val );
    // }
    val = Math.round( val );

    let valArr  = val.toString().replace(/[^\d]/g, '').split('').reverse(),
        average = 3,
        res     = '';

    for ( let i = 0, l = valArr.length; i < l; i++ ) {

        res += valArr[i];

        if ( i % average === average-1 && i < l - 1 ) {
            res += ',';
        }

    }

    res = res.split('').reverse().join('');

    if ( val < 0 ) {
        res = '-' + res;
    }

    return res;

};

// Math animation algorithm
Math.easeInOutSine = function (t, b, c, d) {
    return c * Math.sin(t/d * (Math.PI/2)) + b;
};

// Scroll top animation
export const scrollTo = (element, to, duration) => {

    let start = element.scrollTop,
        change = to - start,
        currentTime = 0,
        increment = 20;

    let animateScroll = function(){
        currentTime += increment;
        element.scrollTop = Math.easeInOutSine(currentTime, start, change, duration);
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
};

// Get name/extension from filename
export const getFileNameExt = ( name ) => {

    name = name.toString();

    const ext = name.substr(name.lastIndexOf('.') + 1);
    const pattern = new RegExp( '.' + ext, 'g' );

    return {
        fileName: name.replace( pattern, '' ),
        fileExt: ext
    };

};

// Get name/extension from filename
export const setCommaDateFormat = ( date ) => {

    date = date.toString();

    let splitDate = date.split(' ');

    if ( splitDate.length > 1 ) {

        let time = splitDate[1].split(':');

        date = splitDate[0].split('-').reverse().join('.') + '; ' + time[0] + ':' + time[1];
    }

    return date;

};
